import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FormlyFormOptions, FormlyModule} from '@ngx-formly/core';
import {NbButtonModule} from '@nebular/theme';
import {BaseComponent, CompoApiService, IdAndHeader} from 'compob2b-libs';
import {Subject} from 'rxjs';
import {map} from 'rxjs/operators';
import {translations} from '../../../../../../environments/translations.ru';
import {CrudConfig} from '../../../../../admin-shared/interfaces/crud.config';

@Component({
  selector: 'app-add-master-card-features',
  templateUrl: './add-master-card-features.component.html',
  styleUrls: ['./add-master-card-features.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, NbButtonModule, ReactiveFormsModule]
})
export class AddMasterCardFeaturesComponent extends BaseComponent implements OnInit {
  @Input() templateId: number;
  @Input() productId: number;

  @Output() featuresChangeEvent = new EventEmitter<boolean>();

  model: any = {};
  form = new FormGroup({});
  options: FormlyFormOptions = {};
  config: CrudConfig;

  uri = '/master-card-template-feature';

  private readonly updateFeaturesEvent = new Subject();

  /** Перезагрузить список свободных характеристик (например, после удаления извне). */
  refresh(): void {
    this.updateFeaturesEvent.next(null);
  }

  constructor(private readonly compoApoService: CompoApiService) {
    super();
  }

  ngOnInit() {
    this.config = {
      uri: this.uri,
      title: translations.addMasterCardFeatures,
      columns: [
        {
          key: 'masterCardFeaturesId',
          className: 'col-3',
          title: translations.addMasterCardFeatures,
          placeholder: translations.addMasterCardFeatures,
          formly: true,
          type: 'select-multi-filter-property',
          templateOptions: {
            label: translations.addMasterCardFeatures,
            placeholder: translations.choose,
            multipleValue: true,
            options: []
          },
          width: '100%',
          grid: false,
          hooks: {
            onInit: (field) => {
              this.getFreeTemplateFeatures()
                .subscribe(freeTemplateFeatures => field.templateOptions.options = freeTemplateFeatures);

              this.updateFeaturesEvent.subscribe(() => {
                this.getFreeTemplateFeatures()
                  .subscribe(freeTemplateFeatures => field.templateOptions.options = freeTemplateFeatures);
                field.formControl.reset();
              });
            }
          }
        }
      ]
    };
  }

  addMasterCardFeatures() {
    const raw = this.model.masterCardFeaturesId;
    const featureIds = Array.isArray(raw)
      ? raw.map(f => typeof f === 'object' && f !== null ? f.value : f)
      : raw;

    this.compoApoService.post(`${this.uri}/product/${this.productId}`, featureIds)
      .subscribe(_ => {
        this.updateFeaturesEvent.next(null);
        this.featuresChangeEvent.emit(true);
      });
  }

  private getFreeTemplateFeatures() {
    return this.compoApoService.get<IdAndHeader[]>(`${this.uri}/product/${this.productId}/free`)
      .pipe(map(response => {
        return response.data.map((item: IdAndHeader) => {
          return {
            value: item.id,
            label: item.header
          };
        });
      }));
  }
}
